import $ from 'jquery';
import { compileTemplate, renderTpl } from "./helpers";
import { AUTO_HIDE_MS } from "./toast";

// Mirrors Handlebars.Utils.isEmpty (the `notEmpty` helper the template guards the determinate bar
// with), so JS and template agree on what "a progress value was passed" means — 0 counts.
const hasValue = (value) => value === 0 || !!value;

export class Notifier {
  wrapperSel = '.notifier';
  templateSel = '.tpl-notifier';

  constructor(){
    this.dict = notifierDict;

    if(typeof this.dict === 'undefined'){
      return false;
    }

    this.initElements();
    this.initTemplates();
  };

  initElements(){
    this.dom = {
      wrapper: document.querySelector(this.wrapperSel),
      template: document.querySelector(this.templateSel),
    };

    $(this.dom.wrapper).on('click', '.close', () => this.hide());
  };

  initTemplates(){
    this.template = {source: this.dom.template.innerHTML, target: this.dom.wrapper};
    compileTemplate(this.template);
  };

  show(subject, options = {}){
    if(typeof this.dict[subject] === 'undefined'){
      return false;
    }

    const opts = Object.assign({}, this.dict[subject], options);

    clearTimeout(this.timer);

    const duration = typeof opts.autoHide === 'number' ? opts.autoHide : AUTO_HIDE_MS;

    // The countdown bar and the determinate `{{progress}}` bar are the same slot in the template:
    // upload/saving toasts carry real percentages (uploader.js) and keep their bar, everything that
    // merely times out gets the countdown instead.
    renderTpl(this.template, {
      message: opts.message,
      variant: opts.variant,
      progress: opts.progress,
      dismissible: opts.dismissible,
      countdown: opts.autoHide && !hasValue(opts.progress) ? duration : null,
    });

    if(opts.autoHide){
      this.timer = setTimeout(() => {this.hide()}, duration)
    }
  };

  hide(){
    this.dom.wrapper.innerHTML = '';
  };
};